module.exports = __webpack_public_path__ + "img/b.d5227393.jpg";